import { createTheme, responsiveFontSizes } from '@mui/material';



export const theme = responsiveFontSizes(createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    h1: {
      fontSize: 50,
      fontWeight: 400,
    },
    h2: {
      fontSize: 30,
      fontWeight: 400,
    },
    h3:{
      fontSize: 20,
      fontWeight: 400,
    },
    h5 :{
      fontSize: 15,
    },
  },
}));
